import React, { useState, useCallback } from 'react'; 
import { Application, extend } from '@pixi/react'; 
import {
  Text as PixiTextClass,
  Graphics as PixiGraphicsClass,
  Container as PixiContainerClass,
  Sprite as PixiSpriteClass
} from 'pixi.js';
import GameComponent from './components/GameComponent';
import PlayerNameInputOverlay from './components/PlayerNameInputOverlay'; 

// Sentry is initialized in main.tsx

extend({
  Text: PixiTextClass,
  Graphics: PixiGraphicsClass,
  Container: PixiContainerClass,
  Sprite: PixiSpriteClass
});

const GAME_WIDTH = 390;
const GAME_HEIGHT = 844;

const App: React.FC = () => {
  const [showNameInputOverlay, setShowNameInputOverlay] = useState(false);
  const [currentScoreForOverlay, setCurrentScoreForOverlay] = useState(0);
  const [submittedNameForGame, setSubmittedNameForGame] = useState<string | null>(null); // New state
  const [submitScoreTrigger, setSubmitScoreTrigger] = useState<number>(0); // New state

  // Called by GameComponent when game is over to show the overlay
  const handleTriggerShowOverlay = useCallback((score: number) => {
    console.log(`App.tsx: GameComponent requests overlay for score: ${score}`);
    setCurrentScoreForOverlay(score);
    setSubmittedNameForGame(null); // Clear previous name when overlay is shown
    setShowNameInputOverlay(true);
  }, []); 

  // Called by PlayerNameInputOverlay when the name is submitted
  const handleOverlayNameSubmitted = useCallback((name: string) => {
    setShowNameInputOverlay(false);
    console.log(`App.tsx: Overlay submitted name '${name}' for score ${currentScoreForOverlay}. Triggering GameComponent to submit.`);
    setSubmittedNameForGame(name);
    setSubmitScoreTrigger(prev => prev + 1); // Increment to trigger effect in GameComponent
  }, [currentScoreForOverlay]); 

  // Called by PlayerNameInputOverlay when it's closed (e.g., cancel button)
  const handleOverlayClosed = useCallback(() => {
    setShowNameInputOverlay(false);
    setSubmittedNameForGame(null); // Clear any pending name if cancelled
    console.log("App.tsx: Overlay closed by user (cancel).");
  }, []);

  return (
    <> {/* Top-level React Fragment */}
      <Application
        width={GAME_WIDTH}
        height={GAME_HEIGHT}
        backgroundColor={0x00FF00} 
        antialias={true}
        autoDensity={true}
        resolution={Math.max(window.devicePixelRatio || 1, 2)}
      >
        <GameComponent
          width={GAME_WIDTH}
          height={GAME_HEIGHT}
          onGameOverShowOverlay={handleTriggerShowOverlay} 
          // New props for GameComponent (its interface will be updated next turn):
          submitName={submittedNameForGame}
          submitScoreTrigger={submitScoreTrigger}
        />
      </Application>
      {showNameInputOverlay && (
        <PlayerNameInputOverlay
          isVisible={true} 
          currentScore={currentScoreForOverlay}
          onSubmitName={handleOverlayNameSubmitted}
          onClose={handleOverlayClosed}
        />
      )}
    </>
  );
};
export default App;
// Rewrite Count: 22